export default __webpack_public_path__ + "static/media/best-app-development-tool.ad3bbdcb.md";